import {
   ServiceProvidingLocation,
   ServiceProvidingLocationForCurrentPracticeQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { Message, MessageType, StandardSpinner } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

type ServiceProvidingLocationDropdownLoaderRenderer = (renderProps: {
   serviceProvidingLocation: ServiceProvidingLocation[];
}) => JSX.Element;

type ServiceProvidingLocationDropdownLoaderProps = {
   readonly withRemovedLocations: boolean;
   readonly children: ServiceProvidingLocationDropdownLoaderRenderer;
};

export const ServiceProvidingLocationDropdownLoader = (
   props: ServiceProvidingLocationDropdownLoaderProps
): JSX.Element => {
   const {
      data: serviceProvidingLocation,
      loading: serviceProvidingLocationLoading,
      error: serviceProvidingLocationError,
   } = useCqrsSearch<ServiceProvidingLocation>(() => {
      const query = new ServiceProvidingLocationForCurrentPracticeQuery();
      query.removed = Slot.emptyIfNull(props.withRemovedLocations ? null : false);
      return query;
   });

   if (serviceProvidingLocationLoading) {
      return <StandardSpinner />;
   }

   if (serviceProvidingLocationError) {
      return (
         <Message
            testId={'serviceProvidingLocationDropdownError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({
      serviceProvidingLocation: serviceProvidingLocation,
   });
};
